export enum TRACK_JS_METADATA_ENUM {
  PAGE_NAME = 'page-name',
  FILE_NAME = 'file-name',
  METHOD_NAME = 'method-name',
  EXCEPTION_CATEGORY = 'exception-category',
  EXCEPTION_MESSAGE = 'exception-message',
  TEA_LEAF_SESSION = 'tea-leaf-session'
}

export enum EXCEPTION_CATEGORY_ENUM {
  JS_CATCH_BLOCK = 'js-catch-block',
  API_FAILURE = 'api-failure',
  API_EMPTY_RESPONSE = 'api-empty-response',
  JS_ERROR = 'js-error'
}
